import { Navigate, Route, Routes } from "react-router-dom";
import Layout from "./components/Layout";
import PagePlaceholder from "./components/PagePlaceholder";
import HomePage from "./pages/HomePage";
import ServicesPage from "./pages/ServicesPage";
import RiskEngineeringPage from "./pages/RiskEngineeringPage";
import StrataPage from "./pages/StrataPage";
import PortfolioAnalyticsPage from "./pages/PortfolioAnalyticsPage";
import CrisisManagementPage from "./pages/CrisisManagementPage";
import KnowledgeCenterPage from "./pages/KnowledgeCenterPage";
import AboutPage from "./pages/AboutPage";
import ContactPage from "./pages/ContactPage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import TermsConditionsPage from "./pages/TermsConditionsPage";
import ReportPage from "./pages/ReportPage";
import SelfAssessmentPage from "./pages/SelfAssessmentPage";
import AssessmentPage from "./pages/AssessmentPage";
import AssessmentReportPage from "./pages/AssessmentReportPage";
import ThankYouPage from "./pages/ThankYouPage";
import "./styles/app-shell.css";

const pages = [{ path: "/comingsoon", title: "Coming Soon" }];

function App() {
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/Services" element={<ServicesPage />} />
        <Route path="/Knowledge-Center" element={<KnowledgeCenterPage />} />
        <Route path="/Knowledge-Centre" element={<KnowledgeCenterPage />} />
        <Route path="/About-us" element={<AboutPage />} />
        <Route path="/Contact-us" element={<ContactPage />} />
        <Route path="/privacypolicy" element={<PrivacyPolicyPage />} />
        <Route path="/termsconditions" element={<TermsConditionsPage />} />
        <Route path="/Report" element={<ReportPage />} />
        <Route path="/SelfAssessment" element={<SelfAssessmentPage />} />
        <Route path="/Assessment" element={<AssessmentPage />} />
        <Route path="/Assessment/report" element={<AssessmentReportPage />} />
        <Route path="/thank-you" element={<ThankYouPage />} />
        <Route
          path="/ContactSuccess"
          element={<PagePlaceholder title="Contact Success" />}
        />

        <Route path="/RiskEngineering" element={<RiskEngineeringPage />} />
        <Route path="/Strata" element={<StrataPage />} />
        <Route
          path="/PortfolioAnalyticsandDataInsights"
          element={<PortfolioAnalyticsPage />}
        />
        <Route
          path="/CrisisManagementandBusinessContinuity"
          element={<CrisisManagementPage />}
        />

        <Route
          path="/PropertyRiskConsulting"
          element={<Navigate replace to="/RiskEngineering" />}
        />
        <Route
          path="/ClientRiskImprovementSupport"
          element={<Navigate replace to="/Strata" />}
        />
        <Route
          path="/PlacementSupport"
          element={<Navigate replace to="/PortfolioAnalyticsandDataInsights" />}
        />
        <Route
          path="/RiskManagementTraining"
          element={<Navigate replace to="/CrisisManagementandBusinessContinuity" />}
        />

        {pages.map((page) => (
          <Route
            key={page.path}
            path={page.path}
            element={<PagePlaceholder title={page.title} />}
          />
        ))}
        <Route path="*" element={<Navigate replace to="/" />} />
      </Routes>
    </Layout>
  );
}

export default App;